import React from "react";

const OS = () => {
  return (
    <div>
      <h1>Operating System Notes</h1>
      <p>Here you will find OS study material.</p>
    </div>
  );
};

export default OS;